import ModelContainer from '@core/scripts/components/model-container';

function load() {
    const navigationModel = ModelContainer.get('navigation');
    const userModel = ModelContainer.get('headerUserModel');
    const wishlistModel = ModelContainer.get('wishlistGlobalModel');
    const notificationsModel = ModelContainer.get('personalNotificationsModel');

    return {
        navigationModel,
        userModel,
        wishlistModel,
        notificationsModel,
    };
}

export default {
    load,
};
